(ns manage.content-configuration-page.predicate.view
  (:require ["@mui/material/Grid$default" :as Grid]
            [clojure.edn :refer [read-string]]
            [common.ui.list :as ui.list]
            [common.widgets.dropdown :refer [dropdown]]
            [manage.content-configuration-page.predicate.expression
             :as predicate-expression]
            [re-frame.core :as rf]
            [uix.core :refer [$]]))

(defn operator [pr]
  (let [{:predicate/keys [operator] :as predicate} (predicate-expression/pull-predicate pr)]
    [dropdown
     {:options @(rf/subscribe [:predicate/operator-options predicate])
      :value operator
      :disabled? @(rf/subscribe [:resource.content-function-version/active-version? "published"])
      :on-change #(rf/dispatch [:predicate/edit-operator predicate (keyword %)])
      :data-testid "trigger-item-operator-select"}]))

(defn expression [pr]
  (let [published? @(rf/subscribe [:resource.content-function-version/active-version? "published"])]
    [predicate-expression/predicate-expression {:disabled? published?
                                                :data-testid "trigger-item-value-select"} pr]))

(defn add-item-cfg [r]
  {:add-item/label "Add trigger"
   :add-item/select-options [:context-source/all-macro-options-with-create-option]
   :add-item/dropdown-props {:data-testid "add-trigger-select"}
   :add-item/add-fn (fn [macro-str]
                      (rf/dispatch [:predicate/create r (read-string macro-str)]))})

(defn label [pr]
  @(rf/subscribe [:macro/label (predicate-expression/pull-predicate pr) " - "]))

(defn entity-view-cfg [pr]
  {:entity/ref pr
   :entity/label [label pr]
   :validation/schema :predicate
   :list-item/details [:> Grid {:container true :spacing 1.5}
                       [:> Grid {:size {:xs 4}}
                        [operator pr]]
                       [:> Grid {:size {:xs 8}}
                        [expression pr]]]})

(defn list-cfg-predicate [{r :eid :as rule}]
  {:entity/ref rule
   :entity/label "Triggers"
   :list/items :rule/condition
   :list/->item-cfg entity-view-cfg
   :list/add-item-cfg (add-item-cfg r)
   :list/empty-msg ($ ui.list/empty-msg {:title "Add triggers to this rule"}
                      ($ :p
                         "To control when a rule is used in a campaign, you are able
                          to add one or multiple triggers here.")
                      ($ :p
                         "Please first select the trigger-type you want to use.
                          Once a trigger is added, you can define the exact
                          conditions for this trigger."))})
